export class HistoryRoutes
{
    static Home = "/"
    //History
    static HistoryList = "/history/list";
    static HistoryView(id: string)
    {
        return `/history/${id}/view`;
    };
}